module.exports = __webpack_public_path__ + "media/components/MenuMobile/open-72934fc2d093b8c37df7a6905688c8a17ef3eff57097deeedfd3cdac16f7ef36.svg";